<template>
	<div class="y-chat-field">
		<label class="y-chat-field__label">
			<input
					type="text"
					v-model="message"
					@keydown.enter="sendMessage"
					:placeholder="$t('enter_your_message')"
					class="y-chat-field__inp"
			/>
		</label>

		<button
				@click="sendMessage"
				type="button"
				class="y-btn y-btn_main y-aspect-ratio y-chat-field__btn"
				aria-label="send message"
		>
			<span class="y-btn__icn">
				<svg width="24" height="24" viewBox="0 0 24 24" style="fill: none" xmlns="http://www.w3.org/2000/svg">
					<path fill-rule="evenodd" clip-rule="evenodd" d="M20.7661 0.130157C22.6843 -0.509235 24.5092 1.31566 23.8698 3.23383L17.5071 22.3219C16.8356 24.3363 14.096 24.6047 13.0464 22.7588L9.15178 15.9097C9.15171 15.9096 9.15164 15.9095 9.15158 15.9094L12.8656 12.1953C13.1585 11.9024 13.1585 11.4276 12.8656 11.1347C12.5727 10.8418 12.0978 10.8418 11.8049 11.1347L8.09103 14.8486C8.09073 14.8484 8.09043 14.8482 8.09013 14.8481L1.24112 10.9535C-0.604721 9.90396 -0.336376 7.16431 1.67805 6.49284L20.7661 0.130157Z" fill="white"/>
				</svg>
			</span>
		</button>
	</div>
</template>

<script>
export default {
	name: "ChatComponent",
	props: {
		messages: Array,
		teacher: '',
		student: ''
	},
	data() {
		return {
			message: null,
			posBoxY: 0,
		}
	},
	computed: {},
	mounted() {
	},
	methods: {
		sendMessage() {
			console.log(this.message)
			this.$emit('sendMessage', {
				message: this.message,

			})
			this.message = '';
		}
	}
}
</script>
